import { NotifyParty } from "../models/notify.party";

import BaseService from "./_base.service";

const ROUTE_NAME = "notifyparty";

const NotifyPartyService = {
  ...BaseService<NotifyParty>({ endpoint: ROUTE_NAME }),
};

export default NotifyPartyService;
